import React from "react";
import {
  Hero,
  Introducing,
  ModularMultiplatformMachine,
  PlugAndPlay,
  Globe,
  FabricFeatures,
} from "../components/Hero";
import Partnership from "../components/Partnership";
import Divider from "../components/Divider";
import Newsletter from "../components/Newsletter";

function Home() {
  return (
    <main className="min-h-screen bg-white">
      {/* Hero Section */}
      <Hero />
      <Introducing />
      <ModularMultiplatformMachine />
      <PlugAndPlay />
      <Globe />
      <FabricFeatures />
      <Newsletter />
      <Divider />
      <Partnership />
    </main>
  );
}

export default Home;
